import { required, email } from 'vuelidate/lib/validators'

export default {
  password: {
    required,
  },
  email: {
    required,
    email
  },
}
